import { string, struct } from 'io-ts/Decoder';

import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Id = iotsUtils.fromList(constants.report.completedDateType.ids);

export const RefItem = struct({
	id: Id,
	name: string,
});
